import { pickLang } from "@/data/stoicosCards";

/* Figure with authenticity badge, localized caption and a compact provenance card.
   Used for the Zeno Material Evidence section and for textually attested reconstructions. */
export const AncientImageFigure = ({ img, lang, labels, portraitNarrow = false }) => {
  const rows = [
    [labels.provDating, img.dating && pickLang(img.dating, lang)],
    [labels.provFindspot, img.findspot && pickLang(img.findspot, lang)],
    [labels.provCollection, img.collection && pickLang(img.collection, lang)],
    [labels.provInv, img.invNo],
    [labels.provRelation, img.relation && pickLang(img.relation, lang)],
    [labels.provConfidence, img.confidence && pickLang(img.confidence, lang)],
    [labels.provSource, img.source && pickLang(img.source, lang)],
    [labels.provRights, img.license],
  ].filter(([, v]) => v);
  return (
    <figure data-testid={`ancient-figure-${img.id}`} className="border border-white/10 bg-ink-elevated/30">
      <div className={portraitNarrow ? "flex justify-center bg-black/30 py-6" : ""}>
        <img
          src={img.src}
          alt={pickLang(img.alt, lang)}
          loading="lazy"
          data-testid={`ancient-image-${img.id}`}
          className={portraitNarrow ? "max-h-[420px] w-auto" : "w-full h-auto"}
        />
      </div>
      <figcaption className="p-5 md:p-6">
        <p data-testid={`ancient-label-${img.id}`} className="text-[10px] tracking-[0.25em] uppercase text-gold">{pickLang(img.typeLabel, lang)}</p>
        <p className="mt-2 font-serif text-lg text-bone">{pickLang(img.title, lang)}</p>
        <p className="mt-2 text-fog/80 font-reading text-sm leading-[1.75]">{pickLang(img.caption, lang)}</p>
        <dl data-testid={`ancient-provenance-${img.id}`} className="mt-4 pt-4 border-t border-white/10 grid grid-cols-1 gap-y-3">
          {rows.map(([k, v]) => (
            <div key={k}>
              <dt className="text-[10px] tracking-[0.2em] uppercase text-fog/55">{k}</dt>
              <dd className="mt-0.5 text-fog/85 font-reading text-[13px] leading-[1.6]">{v}</dd>
            </div>
          ))}
        </dl>
      </figcaption>
    </figure>
  );
};
